import Layout from 'antd/lib/layout/layout'
import styled from 'styled-components'

export const StyledLayout = styled(Layout)``

export const Main = styled.div`
    background-color: white;
    position: relative;
    margin-top: 15px;
    margin-bottom: 30px;
    border-radius: 8px;
    padding: 30px 30px 0;
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
    p {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 10px;
    }
    .notify {
        padding-top: 20px;
    }
    
    .notify p {
        font-size: 12px;
    }
    .planBtn {
        padding: 10px 0;
    }
    
    .planBtn Button {
        background-color: white;
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: ridge;
        border-color: #dbdbdb;
        color: #49a04d;
        font-weight: bold;
        box-shadow: 0px 2px 4px rgba(97, 97, 97, 0.18),
            0px 4px 8px rgba(97, 97, 97, 0.18);
        border-radius: 26px;
    }
    
    .planBtn Button:hover {
        border-color: white!important;
        color: #49a04d;
    }
    
    .planBtn Button:disabled,
    .planBtn Button[disabled] {
        background-color: #cccccc;
        border-color: #d9d9d9;
        box-shadow: none;
        text-shadow: none;
    }
    
    .profile-content {
        background-color: #e2e2e2;
        padding: 0 20px;
    }
}
`
